// src/componentes/Cuerpos/remotework/submodulos/Proveedores/RW_Proveedores.jsx

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PuenteApi from '../../../../../pageauth/PuenteApi';
import Mensaje from '../../../../../Mensaje';
import Cargando from '../../../../../Cargando';
import Swal from 'sweetalert2';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';
import { FaEdit, FaTrash, FaPlus, FaSync, FaSearch, FaSort, FaSortUp, FaSortDown, FaTruck, FaChartLine } from 'react-icons/fa';
import CryptoJS from 'crypto-js';
import AuthUser from '../../../../../pageauth/AuthUser';
import ProveedorModal from '../../../submoduloscomunes/ProveedorModal/ProveedorModal';
import { RW_Proveedores_Comprobantes } from './RW_Proveedores_Comprobantes';

export const RW_Proveedores = () => {
    require('../../Remotework.css?v=1.1.0');
    const { ObtenerProvedoresAdmin, CrearProvedor, ActualizarProvedor, EliminarProvedor, ObtenerEstaciones, ObtenerProvedoresFamilias, CrearProvedorFamilia, ActualizarProvedorFamilia, EliminarProvedorFamilia, ObtenerRazonesSociales } = PuenteApi();
    const { StartCargando, StopCargando } = Cargando();
    const { SetMensaje } = Mensaje();
    const location = useLocation();

    const isContable = location.pathname.includes('/contable');
    const [selectedView, setSelectedView] = useState(isContable ? "estadisticas" : "proveedores");
    const [estaciones, setEstaciones] = useState([]);
    const [proveedoresUnificados, setProveedoresUnificados] = useState([]);
    const [familiasUnificadas, setFamiliasUnificadas] = useState([]);
    const [familiasParaModal, setFamiliasParaModal] = useState([]);
    const [razonesSociales, setRazonesSociales] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [proveedorAEditar, setProveedorAEditar] = useState(null);
    const [busqueda, setBusqueda] = useState("");
    const [busquedaFamilia, setBusquedaFamilia] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: 'razon_social', direction: 'ascending' });

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);

    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

    useEffect(() => {
        cargarEstaciones();
    }, []);

    useEffect(() => {
        if (isContable) {
            if (selectedView !== "estadisticas" && selectedView !== "pagos" && selectedView !== "comprobantes") {
                setSelectedView("estadisticas");
            }
        } else {
            if (selectedView !== "proveedores" && selectedView !== "familias") {
                setSelectedView("proveedores");
            }
        }
    }, [location.pathname]);

    const cargarEstaciones = async () => {
        const estacionesGuardadas = localStorage.getItem("estaciones");
        let listaEstaciones = [];

        if (estacionesGuardadas) {
            try {
                const bytes = CryptoJS.AES.decrypt(estacionesGuardadas, SECRET_KEY);
                listaEstaciones = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                setEstaciones(listaEstaciones);
            } catch (error) {
                console.error("Error decrypting stations", error);
            }
        }

        if (listaEstaciones.length === 0) {
            StartCargando("Cargando estaciones...");
            const response = await ObtenerEstaciones();
            StopCargando();
            if (response) {
                setEstaciones(response);
                listaEstaciones = response;
                localStorage.setItem("estaciones", CryptoJS.AES.encrypt(JSON.stringify(response), SECRET_KEY).toString());
            }
        }

        if (listaEstaciones.length > 0) {
            cargarProveedoresDeTodas(listaEstaciones);
            cargarFamiliasDeTodas(listaEstaciones);
            cargarRazonesSociales(listaEstaciones);
        }
    };

    const cargarRazonesSociales = async (listaEstaciones) => {
        // Fetch Razones Sociales from local or first endpoint to populate filters
        const endpoint = listaEstaciones.find(e => e.local)?.endpoint || listaEstaciones[0]?.endpoint;
        if (endpoint) {
            const res = await ObtenerRazonesSociales(endpoint);
            if (res) {
                setRazonesSociales(res);
            }
        }
    }

    const cargarFamiliasDeTodas = async (listaEstaciones) => {
        StartCargando("Cargando familias...");
        let todasLasFamilias = [];

        for (const estacion of listaEstaciones) {
            const familiasEstacion = await ObtenerProvedoresFamilias(estacion.endpoint);
            if (familiasEstacion) {
                const familiasConEstacion = familiasEstacion.map(f => ({ ...f, estacionId: estacion.id, estacionNombre: estacion.nombre }));
                todasLasFamilias = [...todasLasFamilias, ...familiasConEstacion];

                // If it's the local station, save for the modal
                if (estacion.local) {
                    setFamiliasParaModal(familiasEstacion);
                }
            }
        }

        // If no local station found, use the first one for the modal
        if (todasLasFamilias.length > 0 && !listaEstaciones.some(e => e.local)) {
            const firstEstacionId = listaEstaciones[0].id;
            setFamiliasParaModal(todasLasFamilias.filter(f => f.estacionId === firstEstacionId));
        }

        StopCargando();
        unificarFamilias(todasLasFamilias, listaEstaciones);
    }

    const unificarFamilias = (todasLasFamilias, listaEstaciones) => {
        const mapaFamilias = {};

        todasLasFamilias.forEach(familia => {
            const uniqueKey = familia.codigo || familia.nombre;
            if (!mapaFamilias[uniqueKey]) {
                mapaFamilias[uniqueKey] = {
                    ...familia,
                    estacionesEncontradas: [familia.estacionId],
                    datosPorEstacion: { [familia.estacionId]: familia }
                };
            } else {
                mapaFamilias[uniqueKey].estacionesEncontradas.push(familia.estacionId);
                mapaFamilias[uniqueKey].datosPorEstacion[familia.estacionId] = familia;
            }
        });

        const familiasFinales = Object.values(mapaFamilias).map(familia => {
            const faltanteEn = listaEstaciones.filter(e => !familia.estacionesEncontradas.includes(e.id));
            return {
                ...familia,
                faltanteEn: faltanteEn
            };
        });
        setFamiliasUnificadas(familiasFinales);
    };

    const cargarProveedoresDeTodas = async (listaEstaciones) => {
        StartCargando("Cargando proveedores...");
        let todosLosProveedores = [];

        for (const estacion of listaEstaciones) {
            const proveedoresEstacion = await ObtenerProvedoresAdmin(estacion.endpoint);
            if (proveedoresEstacion) {
                const proveedoresConEstacion = proveedoresEstacion.map(p => ({ ...p, estacionId: estacion.id, estacionNombre: estacion.nombre }));
                todosLosProveedores = [...todosLosProveedores, ...proveedoresConEstacion];
            }
        }
        StopCargando();
        unificarProveedores(todosLosProveedores, listaEstaciones);
    };

    const unificarProveedores = (todosLosProveedores, listaEstaciones) => {
        const mapaProveedores = {};

        todosLosProveedores.forEach(proveedor => {
            const uniqueKey = proveedor.cuit || proveedor.email || proveedor.razon_social;
            if (!mapaProveedores[uniqueKey]) {
                mapaProveedores[uniqueKey] = {
                    ...proveedor,
                    estacionesEncontradas: [proveedor.estacionId],
                    datosPorEstacion: { [proveedor.estacionId]: proveedor }
                };
            } else {
                mapaProveedores[uniqueKey].estacionesEncontradas.push(proveedor.estacionId);
                mapaProveedores[uniqueKey].datosPorEstacion[proveedor.estacionId] = proveedor;
            }
        });

        const proveedoresFinales = Object.values(mapaProveedores).map(proveedor => {
            const faltanteEn = listaEstaciones.filter(e => !proveedor.estacionesEncontradas.includes(e.id));
            return {
                ...proveedor,
                faltanteEn: faltanteEn
            };
        });
        setProveedoresUnificados(proveedoresFinales);
    };

    const handleEditar = (proveedor) => {
        setProveedorAEditar(proveedor);
        setShowModal(true);
    };

    const handleNuevo = () => {
        setProveedorAEditar(null);
        setShowModal(true);
    };

    const handleEliminar = (proveedor) => {
        Swal.fire({
            title: '¿Eliminar proveedor?',
            text: "Se eliminará de TODAS las estaciones donde existe.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                StartCargando("Eliminando...");
                for (const estacionId of proveedor.estacionesEncontradas) {
                    const estacion = estaciones.find(e => e.id === estacionId);
                    if (estacion) {
                        const proveedorEstacion = proveedor.datosPorEstacion[estacionId];
                        await EliminarProvedor(estacion.endpoint, proveedorEstacion.id);
                    }
                }
                StopCargando();
                SetMensaje("OK", "Proveedor eliminado", 3000);
                cargarProveedoresDeTodas(estaciones);
            }
        });
    };

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const proveedoresFiltrados = React.useMemo(() => {
        let items = [...proveedoresUnificados];
        if (busqueda) {
            const t = busqueda.toLowerCase();
            items = items.filter(p => {
                const razonMatch = p.razon_social.toLowerCase().includes(t);
                const cuitMatch = p.cuit?.toLowerCase().includes(t);
                const emailMatch = p.email?.toLowerCase().includes(t);

                // Search in families
                const familyNames = (p.familias || [])
                    .map(fid => familiasParaModal.find(f => f.id === fid)?.nombre || '')
                    .join(' ')
                    .toLowerCase();
                const familyMatch = familyNames.includes(t);

                return razonMatch || cuitMatch || emailMatch || familyMatch;
            });
        }
        if (sortConfig.key) {
            items.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'ascending' ? -1 : 1;
                if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'ascending' ? 1 : -1;
                return 0;
            });
        }
        return items;
    }, [proveedoresUnificados, busqueda, sortConfig, familiasParaModal]);

    const familiasFiltradas = React.useMemo(() => {
        if (!busquedaFamilia) return familiasUnificadas;
        const t = busquedaFamilia.toLowerCase();
        return familiasUnificadas.filter(f =>
            f.nombre.toLowerCase().includes(t) ||
            f.codigo.toLowerCase().includes(t) ||
            f.descripcion?.toLowerCase().includes(t)
        );
    }, [familiasUnificadas, busquedaFamilia]);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = proveedoresFiltrados.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(proveedoresFiltrados.length / itemsPerPage);

    // Familia Handlers
    const handleNuevaFamilia = async () => {
        const { value: formValues } = await Swal.fire({
            title: 'Nueva Familia de Proveedor',
            html:
                '<input id="swal-input1" class="swal2-input" placeholder="Código">' +
                '<input id="swal-input2" class="swal2-input" placeholder="Nombre">' +
                '<input id="swal-input3" class="swal2-input" placeholder="Descripción">',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Guardar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                return {
                    codigo: document.getElementById('swal-input1').value,
                    nombre: document.getElementById('swal-input2').value,
                    descripcion: document.getElementById('swal-input3').value
                }
            }
        });

        if (formValues) {
            if (!formValues.codigo || !formValues.nombre) {
                SetMensaje("Error", "Código y Nombre son requeridos", 3000);
                return;
            }
            StartCargando("Guardando...");
            const endpoint = estaciones.find(e => e.local)?.endpoint || estaciones[0]?.endpoint;
            const res = await CrearProvedorFamilia(endpoint, formValues);
            StopCargando();
            if (res) {
                SetMensaje("OK", "Familia creada correctamente", 3000);
                cargarFamiliasDeTodas(estaciones);
            }
        }
    }

    const handleEditarFamilia = async (familia) => {
        const { value: formValues } = await Swal.fire({
            title: 'Editar Familia',
            html:
                `<input id="swal-input1" class="swal2-input" placeholder="Código" value="${familia.codigo}">` +
                `<input id="swal-input2" class="swal2-input" placeholder="Nombre" value="${familia.nombre}">` +
                `<input id="swal-input3" class="swal2-input" placeholder="Descripción" value="${familia.descripcion || ''}">`,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Actualizar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                return {
                    codigo: document.getElementById('swal-input1').value,
                    nombre: document.getElementById('swal-input2').value,
                    descripcion: document.getElementById('swal-input3').value
                }
            }
        });

        if (formValues) {
            StartCargando("Actualizando...");
            const endpoint = estaciones.find(e => e.local)?.endpoint || estaciones[0]?.endpoint;
            const res = await ActualizarProvedorFamilia(endpoint, familia.id, formValues);
            StopCargando();
            if (res) {
                SetMensaje("OK", "Familia actualizada", 3000);
                cargarFamiliasDeTodas(estaciones);
            }
        }
    }

    const handleEliminarFamilia = (familia) => {
        Swal.fire({
            title: '¿Eliminar familia?',
            text: "Esta acción no se puede deshacer.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                StartCargando("Eliminando...");
                const endpoint = estaciones.find(e => e.local)?.endpoint || estaciones[0]?.endpoint;
                const res = await EliminarProvedorFamilia(endpoint, familia.id);
                StopCargando();
                if (res) {
                    SetMensaje("OK", "Familia eliminada", 3000);
                    cargarFamiliasDeTodas(estaciones);
                }
            }
        });
    }

    return (
        <div className="container-fluid py-4">
            <div className="mb-3">
                {isContable ? (
                    <>
                        <button
                            className={`btn mb-3 ms-2 ${selectedView === "estadisticas" ? "btn-success" : "btn-primary"}`}
                            onClick={() => setSelectedView("estadisticas")}
                        >
                            <FaChartLine /> Estadísticas
                        </button>
                        <button
                            className={`btn mb-3 ms-2 ${selectedView === "pagos" ? "btn-success" : "btn-primary"}`}
                            onClick={() => setSelectedView("pagos")}
                        >
                            <FaSync /> Pagos
                        </button>
                        <button
                            className={`btn mb-3 ms-2 ${selectedView === "comprobantes" ? "btn-success" : "btn-primary"}`}
                            onClick={() => setSelectedView("comprobantes")}
                        >
                            <FaTruck /> Comprobantes
                        </button>
                    </>
                ) : (
                    <>
                        <button
                            className={`btn mb-3 ms-2 ${selectedView === "proveedores" ? "btn-success" : "btn-primary"}`}
                            onClick={() => setSelectedView("proveedores")}
                        >
                            <FaTruck /> Proveedores
                        </button>
                        <button
                            className={`btn mb-3 ms-2 ${selectedView === "familias" ? "btn-success" : "btn-primary"}`}
                            onClick={() => setSelectedView("familias")}
                        >
                            <FaPlus /> Familias/Rubros
                        </button>
                    </>
                )}
            </div>

            {selectedView === "estadisticas" && (
                <div className="card p-4 shadow-sm" style={{ margin: '0 auto' }}>
                    <h3 className="text-primary">Estadísticas de Proveedores</h3>
                    <center><p>Próximamente...</p></center>
                </div>
            )}

            {selectedView === "pagos" && (
                <div className="card p-4 shadow-sm" style={{ margin: '0 auto' }}>
                    <h3 className="text-primary">Pagos a Proveedores</h3>
                    <center><p>Próximamente...</p></center>
                </div>
            )}

            {selectedView === "comprobantes" && (
                <RW_Proveedores_Comprobantes
                    estaciones={estaciones}
                    proveedores={proveedoresUnificados}
                    razonesSociales={razonesSociales}
                />
            )}

            {selectedView === "proveedores" && (
                <div className="card shadow-sm p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="text-primary mb-0">Gestión de Proveedores</h4>
                        <Button variant="primary" onClick={handleNuevo}>
                            <FaPlus className="me-2" /> Agregar Proveedor Global
                        </Button>
                    </div>
                    <div className="mb-4">
                        <div className="input-group" style={{ maxWidth: '400px' }}>
                            <Form.Control
                                type="text"
                                placeholder="Buscar por nombre, CUIT o familia..."
                                value={busqueda}
                                onChange={(e) => setBusqueda(e.target.value)}
                                className='buscador'
                            />
                        </div>
                    </div>

                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th onClick={() => requestSort('razon_social')} style={{ cursor: 'pointer' }}>Razón Social</th>
                                <th onClick={() => requestSort('cuit')} style={{ cursor: 'pointer' }}>CUIT</th>
                                <th>Codigo</th>
                                <th>Sincronización</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map(p => (
                                <tr key={p.id}>
                                    <td>
                                        <div className="fw-bold text-primary">{p.razon_social}</div>
                                        Familias:
                                        {(p.familias || []).map(fid => {
                                            const f = familiasParaModal.find(fam => fam.id === fid);
                                            return f ? (
                                                <small className="text-muted"> {f.nombre},</small>
                                            ) : null;
                                        })}
                                    </td>
                                    <td>{p.cuit}</td>
                                    <td>
                                        {p.codigo && <span key={p.id} className="badge bg-info text-dark me-1">
                                            {p.codigo}
                                        </span>}

                                    </td>
                                    <td>
                                        {p.faltanteEn.length > 0 ? (
                                            <div>
                                                <span className="text-warning fw-bold"><small>Incompleto</small></span>
                                                <ul className="mb-0 ps-3">
                                                    {p.faltanteEn.map(e => (
                                                        <li key={e.id} className="d-flex justify-content-between align-items-center">
                                                            <small>{e.nombre}</small>
                                                            <Button variant="outline-success" size="sm" className="py-0 px-1 ms-1" onClick={() => {/* handleSincronizar(p, e) */ }} title="Sincronizar">
                                                                <FaSync size={10} />
                                                            </Button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        ) : (
                                            <span className="text-success fw-bold"><small>Sincronizado</small></span>
                                        )}
                                    </td>
                                    <td>
                                        <div className="d-flex gap-2">
                                            <Button variant="warning" size="sm" onClick={() => handleEditar(p)} title="Editar Globalmente">
                                                <FaEdit />
                                            </Button>
                                            <Button variant="danger" size="sm" onClick={() => handleEliminar(p)} title="Eliminar Globalmente">
                                                <FaTrash />
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    {totalPages > 1 && (
                        <div className="d-flex justify-content-center mt-3">
                            <Pagination>
                                <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                                {[...Array(totalPages)].map((_, i) => (
                                    <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
                                        {i + 1}
                                    </Pagination.Item>
                                ))}
                                <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
                            </Pagination>
                        </div>
                    )}
                </div>
            )}

            {selectedView === "familias" && (
                <div className="card shadow-sm p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h4 className="text-primary mb-0">Gestión de Familias / Rubros</h4>
                        <Button variant="success" onClick={handleNuevaFamilia}>
                            <FaPlus className="me-2" /> Nueva Familia
                        </Button>
                    </div>
                    <div className="mb-4">
                        <div className="input-group" style={{ maxWidth: '400px' }}>
                            <Form.Control
                                type="text"
                                placeholder="Buscar familia..."
                                value={busquedaFamilia}
                                onChange={(e) => setBusquedaFamilia(e.target.value)}
                                className='buscador'
                            />
                        </div>
                    </div>

                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>Código</th>
                                <th>Nombre</th>
                                <th>Descripción</th>
                                <th>Sincronización</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {familiasFiltradas.length > 0 ? familiasFiltradas.map(f => (
                                <tr key={f.id}>
                                    <td><span className="badge bg-secondary">{f.codigo}</span></td>
                                    <td className="fw-bold">{f.nombre}</td>
                                    <td>{f.descripcion}</td>
                                    <td>
                                        {f.faltanteEn.length > 0 ? (
                                            <div>
                                                <span className="text-warning fw-bold"><small>Incompleto</small></span>
                                                <ul className="mb-0 ps-3">
                                                    {f.faltanteEn.map(e => (
                                                        <li key={e.id} className="d-flex justify-content-between align-items-center">
                                                            <small>{e.nombre}</small>
                                                            <Button variant="outline-success" size="sm" className="py-0 px-1 ms-1" onClick={() => {/* handleSincronizarFamilia(f, e) */ }} title="Sincronizar">
                                                                <FaSync size={10} />
                                                            </Button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        ) : (
                                            <span className="text-success fw-bold"><small>Sincronizado</small></span>
                                        )}
                                    </td>
                                    <td>
                                        <div className="d-flex gap-2">
                                            <Button variant="warning" size="sm" onClick={() => handleEditarFamilia(f)}>
                                                <FaEdit />
                                            </Button>
                                            <Button variant="danger" size="sm" onClick={() => handleEliminarFamilia(f)}>
                                                <FaTrash />
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan="5" className="text-center text-muted">No se encontraron familias</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            )}

            <ProveedorModal
                isVisible={showModal}
                onClose={() => {
                    setShowModal(false);
                    cargarProveedoresDeTodas(estaciones);
                }}
                SetMensaje={SetMensaje}
                proveedorToEdit={proveedorAEditar}
                endpoint={estaciones.find(e => e.local)?.endpoint}
            />
        </div>
    );
};
